import CommonText, {
  TextUiProps,
} from 'common/components/entities/TextNew/ui/TextUi'
import React from 'react'
import type { ActiveInterface } from 'src/shared/schemas/active.schema'
import type { HoverInterface } from 'src/shared/schemas/hover.schema'
import type {
  WebsiteButtonsInterface,
  WebsiteThemeInterface,
  WebsiteTypographySettingsStylesInterface,
} from 'src/shared/types/website-settings-types'

export interface PublicPageLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
    Omit<TextUiProps, 'textAlign'> {
  linkButton?: Partial<WebsiteButtonsInterface>
  paragraph?: WebsiteTypographySettingsStylesInterface
  theme?: WebsiteThemeInterface
  textAlign?: TextUiProps['textAlign']
}

export const PublicPageLink: React.FC<PublicPageLinkProps> = ({
  linkButton,
  paragraph,
  theme,
  style,
  textAlign = 'left',
  href,
  children,
  ...anchorProps
}) => {
  const color = theme?.links.linkTextColor
  const typography = linkButton?.typography ?? paragraph
  const hover: HoverInterface = {
    backgroundColor: theme?.links.linkHoveredBackgroundColor,
  }
  const active: ActiveInterface = {
    backgroundColor: theme?.links.linkPressedBackgroundColor,
  }

  return (
    <CommonText
      as="a"
      href={href}
      color={color}
      linkColor={color}
      fontFamily={typography?.fontFamily}
      fontSize={typography?.fontSize}
      lineHeight={typography?.lineHeight}
      letterSpacing={typography?.letterSpacing}
      fontStyle={typography?.fontStyle}
      fontWeight={typography?.fontWeight}
      textAlign={textAlign}
      mobileFontFamily={typography?.mobileFontFamily}
      mobileFontSize={typography?.mobileFontSize}
      mobileLineHeight={typography?.mobileLineHeight}
      mobileLetterSpacing={typography?.mobileLetterSpacing}
      mobileFontStyle={typography?.mobileFontStyle}
      mobileFontWeight={typography?.mobileFontWeight}
      hover={hover}
      active={active}
      {...anchorProps}
      style={{ ...style, textDecoration: 'none' }}
    >
      {children}
    </CommonText>
  )
}
